import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/faq';
import { business } from '../data/content';
import { useEstimate } from '../contexts/EstimateContext';
const ease = [0.23, 1, 0.32, 1] as const;
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  const {
    openEstimate
  } = useEstimate();
  return <section id="faq" className="scroll-mt-20 bg-white py-20 md:py-24" data-id="element-151" data-mp="249pu1jduqnzf">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 md:px-8 lg:grid-cols-[0.7fr_1.3fr] lg:gap-16" data-id="element-152" data-mp="28b1fdcpp0n1t">
        <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-153" data-mp="1uibr11moz61j">
          <h2 className="font-display text-3xl font-bold leading-tight text-forest md:text-5xl" data-id="element-154" data-mp="1zihk8m8m10lq">Frequently Asked Questions</h2>
          <p className="mt-4 text-lg text-ink-muted" data-id="element-155" data-mp="2n7sc1e7zfknq">Still have a question? We’re happy to help.</p>
          <div className="mt-6 flex flex-col items-start gap-3" data-id="element-156" data-mp="2rz0lga9bb60w">
            <button type="button" onClick={() => openEstimate()} className="rounded-md bg-brick px-5 py-3 text-sm font-semibold text-white transition-colors duration-150 hover:bg-brick-dark" data-id="element-157" data-mp="14va9vs932mzq">
              Get a Free Estimate
            </button>
            <a href={business.phoneHref} className="text-sm font-semibold text-forest hover:text-forest-light" data-id="element-158" data-mp="19udgvi8mj3ac">
              Or call {business.phoneDisplay}
            </a>
          </div>
        </div>

        <ul className="divide-y divide-stone-line border-y border-stone-line" data-id="element-159" data-mp="1jkgiu7xq3rkt">
          {faqs.map((item, i) => {
          const isOpen = open === i;
          const panelId = `faq-panel-${i}`;
          return <li key={item.q} data-id="element-160" data-mp="1skmt7ky4kbfr" data-mpi={i}>
                <h3 data-id="element-161" data-mp="1slo49pf54xxh">
                  <button type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-6 py-5 text-left text-lg font-semibold text-ink transition-colors duration-150 hover:text-forest" data-id="element-162" data-mp="1sj1xvt3zkogu">
                    {item.q}
                    <PlusIcon className={`h-5 w-5 shrink-0 text-forest transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-163" data-mp="286rbl4fbu1rg" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-164" data-mp="2m5r2yju84urb">
                  {isOpen && <motion.div id={panelId} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease
              }} className="overflow-hidden" data-id="element-165" data-mp="2qximwbivk28h">
                      <p className="max-w-2xl pb-5 leading-relaxed text-ink-muted" data-id="element-166" data-mp="t9yato3ksaqv">{item.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}